import React, { Component, Fragment } from 'react';
import styled, { withTheme } from 'styled-components';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import ReportStore from '../../flux/reports/ReportStore';
import collectionTypeToParentType from '../../utils/collectionTypeToParentType';
import ReportStoreActions from '../../flux/reports/ReportStoreActions';
import UserReport from './UserReport';
import generateReportUrl from '../../utils/reports/generateReportUrl';
import isUserActive from '../../utils/reports/isUserActive';
import CountryStoreReport from './CountryStoreReport';
import getStoreName from '../../utils/reports/getStoreName';
import formatUsername from '../../utils/reports/formatUsername';
import CollectionRegionReport from './CollectionRegionReport';
import getRedirectProps from '../../utils/reports/getRedirectProps';
import ReportLoadingError from './ReportLoadingError';
import StoreSuggestion from './StoreSuggestion';
import StoreReportProblem from './StoreReportProblem';

function getStoreThronName(data, params) {
  const store = data.find(({ store_id }) => store_id === params.store);

  return store !== undefined
    ? store.store_thron_name
    : params.store;
}

function getUser(data, params) {
  return data.find(user => (
    user.username === params.username &&
    user.store_id === params.store
  ));
}

function formatUserProps(data, params) {
  const user = getUser(data, params);

  const username = user === undefined
    ? params.username
    : formatUsername(user);

  const isActive = user === undefined
    ? false
    : isUserActive(user);

  return {
      username,
      storeName: getStoreName(data, params),
      storeThronName: getStoreThronName(data, params),
      isActive,
    };
}

class ReportViewContainer extends Component {
  state = {
    collectionType: this.props.collectionType,
    parentId: this.props.parentId,
    isLoading: false,
    error: null,
    data: [],
  };

  subscriptions = [];

  static getDerivedStateFromProps(nextProps, prevState) {
    const { collectionType, parentId } = nextProps;

    if (
      collectionType !== prevState.collectionType ||
      parentId !== prevState.parentId
    ) {
      return { collectionType, parentId };
    }

    return null;
  }

  componentDidMount() {
    this.fetchReportData();

    this.subscriptions.push(ReportStore.addListener(() => {
      const { loading, error, data } = ReportStore.getState();
      const redirectProps = getRedirectProps(data);

      this.setState({
        isLoading: loading,
        error,
        data,
      }, () => {
        if (redirectProps !== null) {
          setTimeout(() => {
            const path = generateReportUrl(
              this.props.match.params.collectionType,
              { ...this.props.match.params, ...redirectProps }
            );

            this.props.history.replace(path);
          }, 0);
        }
      });
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.collectionType !== this.state.collectionType ||
      prevState.parentId !== this.state.parentId
    ) {
      this.fetchReportData();
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  fetchReportData = () => {
    ReportStoreActions.fetch(
      collectionTypeToParentType(this.props.collectionType),
      this.props.parentId
    );

    this.setState({ isLoading: true });
  };

  render() {
    if (this.state.error !== null) {
      return (
        <ReportLoadingError />
      )
    }

    return (
      <Container>
        <Switch>
          <Route path="/reports/:collectionType/:parentId/:region/:country/:store/suggestion" render={props => (
            <StoreSuggestion {...props} data={this.state.data} />
          )} />

          <Route path="/reports/:collectionType/:parentId/:region/:country/:store/report-problem" render={props => (
            <StoreReportProblem {...props} data={this.state.data} />
          )} />

          <Route path="/reports/:collectionType/:parentId/:region/:country/:store/:username" exact render={({ match }) => {
            const { username, storeName, storeThronName, isActive } = formatUserProps(this.state.data, match.params);

            return (
              <UserReport
                match={match}
                username={username}
                storeName={storeName}
                storeThronName={storeThronName}
                isActive={isActive}
              />
            );
          }} />

          <Route path="/reports/:collectionType/:parentId/:region/:country/:store?" render={({ match, history}) => (
            <CountryStoreReport
              match={match}
              history={history}
              isLoading={this.state.isLoading}
              data={this.state.data.filter(row => (
                row.region_code === match.params.region &&
                row.country === match.params.country
              ))} />
          )} />

          <Route path="/reports/:collectionType/:parentId/:region?" render={({ match }) => (
            <CollectionRegionReport
              match={match}
              isLoading={this.state.isLoading}
              data={this.state.data} />
          )} />
        </Switch>
      </Container>
    );
  }
}

export default withRouter(ReportViewContainer);

const Container = styled.div`

`;
